import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormPentagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconFormPentagon"><Path d="M10.9715 2.07029C11.5848 1.62496 12.4149 1.62489 13.0281 2.07029L21.1258 7.95311C21.7391 8.39871 21.9957 9.18917 21.7615 9.91014L18.6688 19.4287C18.4345 20.1497 17.7618 20.6376 17.0037 20.6377H6.99591C6.23776 20.6377 5.56515 20.1497 5.33087 19.4287L2.2381 9.91014C2.00384 9.18911 2.26051 8.39873 2.87384 7.95311L10.9715 2.07029Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormPentagon;
